.tabs {
  display: flex;
  gap: 2px;
  min-inline-size: 0;
  overflow-x: auto;
}

.tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  block-size: var(--control-height);
  padding: 0 10px;
  border: 0;
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--text-muted);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  cursor: pointer;
}

.tab:hover {
  background: var(--state-hover);
  color: var(--text);
}

.tab:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.tab[aria-selected="true"] {
  background: var(--state-active);
  color: var(--text);
}

/* `--text-muted`, not `--text-subtle`: the count must keep its contrast on the selected tab's
   `--state-active` background too (axe color-contrast, mockup v3 P8 gallery counts). */
.count {
  color: var(--text-muted);
  font-size: var(--font-size-12);
  font-variant-numeric: tabular-nums;
}
